"use client";
import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  id?: string;
  label: string | ReactNode;
  selected?: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  description?: string;
  removeHover?: boolean;
  allThemesWithWhiteBackground?: boolean;
  disabled?: boolean;
  className?: string;
  radioButtonOnRightSide?: boolean;
  removePadding?: boolean;
  labelClass?: string;
}

// TODO => colors are hardcoded
const RadioButton = ({
  id,
  label,
  selected,
  name,
  onChange = () => {},
  value,
  description,
  removeHover,
  allThemesWithWhiteBackground = false,
  disabled,
  className,
  radioButtonOnRightSide,
  removePadding,
  labelClass,
}: Props) => {
  return (
    <div
      className={twMerge(
        className,
        "flex items-center w-full py-2 px-4 rounded-lg",
        removeHover || disabled
          ? ""
          : "hover:night:bg-[#2a2a2a] hover:bg-endemicGray-100",
        radioButtonOnRightSide && "flex-row-reverse justify-between",
        removePadding && "px-0 rounded-none",
      )}
    >
      <div className="rounded-full w-5 h-5 flex items-center relative shrink-0 grow-0">
        <input
          checked={value === selected}
          value={value}
          type="radio"
          className={twMerge(
            "appearance-none border-2 bg-primary rounded-full border-endemicGray-300 absolute w-full h-full night:border-grey night:bg-primary checked:border-[6px] checked:border-black checked:night:border-primary",
            !disabled && "cursor-pointer",
          )}
          name={name}
          onChange={onChange}
          disabled={disabled}
          id={id || value}
        />
      </div>
      <label
        className={twMerge(
          "flex flex-col ml-3 text-body-2 font-normal text-primary night:text-primary w-full",
          allThemesWithWhiteBackground ? "text-endemicGray" : "",
          radioButtonOnRightSide && "ml-0",
          labelClass,
        )}
        htmlFor={id || value}
      >
        <span>{label}</span>
        {description && <span className="text-body-4">{description}</span>}
      </label>
    </div>
  );
};

export default RadioButton;
